<template>
  <div :class="classList">
    <label>{{ label }}</label>
    <datepicker
      :disabled-dates="disabledPastDates"
      class="date-picker form-control registration-date"
      :initial-view="initialView"
      v-model="inputVal"
    ></datepicker>
    <p class="required-message" v-if="!inputVal && submitClicked && isRequired">
      This field is required.
    </p>
  </div>
</template>
<script>
/* This component includes a label, and a date picker
Any error of user input for the date picker (for example: required field, invalid day ...) is showed in this component */

import Datepicker from "vuejs-datepicker";
export default {
  name: "DatePickerWithLabel",
  components: {
    Datepicker
  },
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: [String, Date],
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // Initial view: year or month
    initialView: {
      type: String,
      default: "year"
    },
    // Allow to input date in the past
    allowPastDate: {
      type: Boolean,
      default: true
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    }
  },
  // created() {
  //   this.$emit("input", this.dateInDjangoFormat(new Date()));
  // },
  computed: {
    inputVal: {
      get() {
        if (this.value == null) {
          return null;
        }
        return this.value + "T00:00:00"; // This is to prevent the date from going one day behind
      },
      set(val) {
        this.$emit("input", this.dateInDjangoFormat(val));
      }
    },
    disabledPastDates() {
      if (this.allowPastDate) {
        return {};
      }
      const today = new Date();
      return {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/DatePickerWithLabel.vue